export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="w-full bg-foreground-950 text-background-200">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-bold text-sm">
                桃
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                桃花影院
              </span>
            </div>
            <p className="text-xs md:text-sm text-foreground-400 leading-relaxed mb-5">
              桃花影院是国内领先的免费在线电影院，提供高清不缓冲的观影体验，涵盖最新电视剧全集、热门电影、综艺、动画等丰富内容。永久免费无需会员，让每一个人都能自由享受影视的魅力。
            </p>
            <div className="flex items-center gap-3">
              <a href="#hero" onClick={(e) => { e.preventDefault(); scrollTo('#hero'); }} className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#hero" onClick={(e) => { e.preventDefault(); scrollTo('#hero'); }} className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#hero" onClick={(e) => { e.preventDefault(); scrollTo('#hero'); }} className="w-8 h-8 flex items-center justify-center rounded-lg bg-foreground-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-mail-line text-sm"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {[
                { label: '热播榜单', href: '#ranking' },
                { label: '精选推荐', href: '#cards' },
                { label: '影视分类', href: '#index' },
                { label: '焦点推荐', href: '#carousel' },
                { label: '精彩速递', href: '#media' },
              ].map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    onClick={(e) => { e.preventDefault(); scrollTo(item.href); }}
                    className="text-xs md:text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">帮助中心</h4>
            <ul className="space-y-2.5">
              {[
                { label: '常见问题', href: '#faq' },
                { label: '联系我们', href: '#contact' },
                { label: '关于我们', href: '#about' },
                { label: '平台优势', href: '#features' },
                { label: '最新动态', href: '#updates' },
              ].map((item) => (
                <li key={item.label}>
                  <a
                    href={item.href}
                    onClick={(e) => { e.preventDefault(); scrollTo(item.href); }}
                    className="text-xs md:text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-xs text-foreground-500 leading-relaxed">
              桃花影院始终秉持开放合作的态度，期待与更多优质内容方、品牌方携手共建更好的免费观影生态。合作咨询请通过「联系我们」版块获取联系方式。
            </p>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-foreground-800">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-foreground-500">
            <p>© 2022 - 2026 桃花影院 taohua-cinema.com 版权所有</p>
            <p>本站所有影视资源均来自互联网公开分享，仅供交流学习使用</p>
          </div>
        </div>
      </div>
    </footer>
  );
}